export interface ModelChoice {
  readonly id: string;
  readonly label: string;
  readonly description: string;
}

const OPENAI_MODELS: readonly ModelChoice[] = Object.freeze([
  { id: "gpt-5.5", label: "GPT-5.5", description: "Default — strongest proven workflow" },
  { id: "gpt-5.6-sol", label: "GPT-5.6 Sol", description: "Highest capability" },
  { id: "gpt-5.6-terra", label: "GPT-5.6 Terra", description: "Balanced intelligence and cost" },
  { id: "gpt-5.6-luna", label: "GPT-5.6 Luna", description: "Cost-sensitive workloads" },
  { id: "gpt-5.4", label: "GPT-5.4", description: "Previous-generation fallback" },
]);

const ANTHROPIC_MODELS: readonly ModelChoice[] = Object.freeze([
  { id: "claude-fable-5", label: "Claude Fable 5", description: "Highest available capability" },
  {
    id: "claude-opus-5",
    label: "Claude Opus 5",
    description: "Complex coding and enterprise work",
  },
  {
    id: "claude-sonnet-5",
    label: "Claude Sonnet 5",
    description: "Balanced speed and intelligence",
  },
  {
    id: "claude-haiku-4-5-20251001",
    label: "Claude Haiku 4.5",
    description: "Fastest current Claude model",
  },
]);

const DEEPSEEK_MODELS: readonly ModelChoice[] = Object.freeze([
  { id: "deepseek-v4-pro", label: "DeepSeek V4 Pro", description: "Higher-capability V4 model" },
  { id: "deepseek-v4-flash", label: "DeepSeek V4 Flash", description: "Lower-latency V4 model" },
]);

const MODEL_CATALOG: Readonly<Record<string, readonly ModelChoice[] | undefined>> = Object.freeze({
  openai: OPENAI_MODELS,
  "openai-oauth": OPENAI_MODELS,
  anthropic: ANTHROPIC_MODELS,
  "anthropic-oauth": ANTHROPIC_MODELS,
  deepseek: DEEPSEEK_MODELS,
});

export function modelsForProvider(providerId: string): readonly ModelChoice[] {
  return MODEL_CATALOG[providerId] ?? [];
}
